export enum ORGANIZATION_SETTINGS_SIDEBAR_ITEMS {
  PUBLIC_INFO = 'public-info',
  LEGAL_INFO = 'legal-info',
  MANAGE_TEAM = 'manage-team',
  MICETRIBE_ADMIN = 'micetribe-admin',
  WEB_HOOKS = 'webhooks',
  API_KEYS = 'api-keys',
  BILLING = 'billing'
}
